<!--收款单-->
<template>
  <div class="app-container">
    <el-card class="box-card">
      <dynamic-search :data="tableFilterList(tableHead)" @search="dataTableSearch">
        <template v-slot:next>
          <el-button icon="el-icon-plus" @click="add()">新增</el-button>
          <el-button icon="el-icon-upload2" @click="downloadExcel()">导出</el-button>
          <el-popover placement="bottom" trigger="click" v-if="isExportStatistics">
                  <el-date-picker
                  v-model="selectMonths"
                  type="month"
                  format="yyyy-MM"
                  placeholder="选择月份"
                  value-format="yyyy-MM"
                >
                </el-date-picker><br/>
                 <p style="float:right"> <el-button size="mini" class="el-button--success link-left" :loading="loading" @click="exportStatisticsExcel(0)">确定</el-button></p>
                  <el-button style="margin-left:10px;" slot="reference" icon="el-icon-edit-outline" >导出月度汇总报表</el-button>
          </el-popover>
          <el-popover placement="bottom" trigger="click" v-if="isExportStatistics">
                  <el-date-picker
                  v-model="selectYear"
                  type="year"
                  format="yyyy"
                  placeholder="选择年份"
                  value-format="yyyy"
                  :picker-options="{'firstDayOfWeek': 1}"
                >
                </el-date-picker><br/>
                 <p style="float:right"> <el-button size="mini" class="el-button--success link-left" :loading="loading" @click="exportStatisticsExcel(1)">确定</el-button></p>
                  <el-button style="margin-left:10px;" slot="reference" icon="el-icon-edit-outline" >导出年度汇总报表</el-button>
          </el-popover>
        </template>
      </dynamic-search>
      <edit-data-table
        :head="tableHead"
        :data.sync="list"
        :config="{trigger: 'click', mode: 'cell'}"
        :total="total"
        :offset="offset"
        :page="page"
        :loading="loading"
        stripe
        border
        @handlePageChange="dataTablePageChange"
        @handleSizeChange="dataTableSizeChange"
      >
      <template v-slot:receiptType="scope">
          <div v-for="item in receiptTypes" :key="item.id">
            <span v-if="scope.row.receiptType === item.value">{{ item.label }}</span>
          </div>
      </template>
        <template #toolbar="scope">
           <el-button type="text" size="mini" icon="el-icon-view" @click="view(scope.row)"></el-button>
          <el-button type="text" size="mini" icon="el-icon-edit" v-if="statusEdit(scope.row.billState)" @click="edit(scope.row)"></el-button>
            <!-- <el-popover
            :ref="scope.row.id"
            placement="top"
            width="220"
            v-if="scope.row.billState === 2"
          >
            <p>确定退回该立项交付单据吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="$refs[scope.row.id].doClose()">取消</el-button>
               <el-button type="primary" size="mini" @click="reject(scope.row)">退回</el-button>
            </div>
            <el-button type="text" size="mini" icon="el-icon-back" slot="reference"></el-button>
          </el-popover> -->
          <!-- <el-popover
            :ref="scope.row.id"
            placement="top"
            width="180"
             v-if="statusUnAudit(scope.row.billState)"
          >
            <p>确定反审核该收款单据吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="$refs[scope.row.id].doClose()">取消</el-button>
               <el-button type="primary" size="mini" @click="reject(scope.row, 5)">确定</el-button>
            </div>
            <el-button type="text" size="mini" icon="el-icon-circle-close" slot="reference"></el-button>
          </el-popover> -->
          <el-popover :ref="scope.row.id" placement="top" width="180" v-if="statusEdit(scope.row.billState)">
            <p>确定删除本条数据吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="$refs[scope.row.id].doClose()">取消</el-button>
              <el-button type="primary" size="mini" @click="subDelete(scope.row.id)">确定</el-button>
            </div>
            <el-button type="text" size="mini" icon="el-icon-delete" slot="reference"></el-button>
          </el-popover>
        </template>
      </edit-data-table>
    </el-card>
  </div>
</template>

<script>
import "@/components/EditDataTable";
import DynamicSearch from "@/components/DynamicSearch";
import DataTableMixin from "@/mixins/DataTableMixin";
import { delReceipt,updateReceipt,getRole,exportStatisticsExcel } from "@/api/bill/receipt";
import {tableSataus} from '@/views/bill/mixins/status'
import initDict from "@/mixin/initDict";
import { downloadExcel } from "@/api/bill/ProjectPlan";
export default {
  name: "PartnerBudgetTask",
  components: {
    DynamicSearch
  },
  mixins: [DataTableMixin,tableSataus,initDict],
  data() {
    return {
      isExportStatistics: false,
      selectMonths: '',
      selectYear: '',
      tableHead: [
         {
          label: "单据编号",
          prop: "code",
        },
        {
          label: "项目",
          prop: "projectDelivery.bsProject.name",
            query: {
            type: "input"
          },
        },
        {
          label: "项目经理",
          prop: "projectDelivery.personManager.name",
        },
        {
          label: "经营人",
          prop: "invoicingApply.contractEntry.personManage.name"
        },
        {
          label: "客户名称",
          prop: "invoicingApply.contractEntry.customerSigning.name"
        },
        {
          label: "收款类型",
          prop: "receiptType",
          slot: 'receiptType'
        },
        {
          label: "收款时间",
          prop: "receiptTime",
         valueFormat: "yyyy-MM-dd"
        },
        {
          label: "金额",
          prop: "balance"
        },
         {
          label: "状态",
          prop: "billState",
            formatter: (state) => {
              return this.statusName(state)
            }
        }
      ],
      receiptTypes: []
    };
  },
  created() {
    // 列表数据初始化
    this.$nextTick(() => {
      this.dataTableInit();
    });
     // 收款方式
     this.getDict("RECEIPT").then(res => {
      this.receiptTypes = res.data;
    });
    // 获取角色
    getRole().then(res => {
      if (res.code === 200) {
        if (res.data < 2) {
          this.isExportStatistics = true;
        }
      }
    })
  },
  methods: {
     exportStatisticsExcel(type) {
       var that = this;
       that.loading = true;
       const p = {};
       console.log(type);
       if (type === 0) {
          p.date = this.selectMonths;
       } else {
          p.year = this.selectYear;
       }
      that.downloadLoading = that.$loading({
        lock: true,
        text: '数据导出中...,请稍后',
        spinner: 'el-icon-loading',
        background: 'rgba(0,0,0,0.7)'
      });
      exportStatisticsExcel(that,p);
    },
      // 导出
      downloadExcel() {
        const obj = Object.keys(this._query)
      const query = {projectName: this._query[obj[0]]}
        downloadExcel('/receipt/exportBizReceiptExcel',query,'收款单')
      },
    dataTableBeforeInit() {
      this._url = "/receipt";
      const params = { page: this.page, size: this.offset};
        // const query = {projectName: this._query.projectDelivery.bsProject.name}
      const obj = Object.keys(this._query)[0]
      const query = {projectName: this._query[obj]}
      this._params = Object.assign(params, query);
      return true;
    },
    dynamicSearch() {},
     view(row) {
      // this.$router.push({path: "receipt/form" ,query: { id: row.id,isEdit: 0}});
       this.$router.push({name: "ReceiptForm" ,params: { id: row.id,isEdit: 0 }})
    },
    add() {
      //  this.$router.push({path: "receipt/form" ,query: {isEdit: 1}});
       this.$router.push({name: "ReceiptForm"})
    },
    edit(row) {
      // this.$router.push({path: "receipt/form" ,query: { id: row.id,isEdit: 1}});
       this.$router.push({name: "ReceiptForm" ,params: { id: row.id,isEdit: 1 }})
    },
    audit(data) { // 审核
      this.updata({id: data.id,billState: 3});
      this.$refs[data.id].doClose()
    },
    // 4退回 5 反审核
    reject(data, status = 4) {
      this.updata({id: data.id, billState: status});
      this.$refs[data.id].doClose()
    },
    updata(data) {
      updateReceipt(data).then(res => {
        if (res.code === 200) {
          this.$notify({
            title: '操作成功',
            type: "success",
            duration: 2500
          });
           this.dataTableInit();
        }
      });
    },
    // 删除
    subDelete(id) {
      delReceipt(id).then(res => {
        this.dataTableInit();
        this.$notify({
          title: "删除成功",
          type: "success",
          duration: 2500
        });
      });
    }
  }
};
</script>

<style scoped lang="scss">
</style>
